import * as tConst from "../Common/Constants";
import { Ticket } from "../services/Ticket";



export function pickColorAdo(item: Ticket, dimColor: boolean): string {


  const status: string = item.state
  const planningStatus: string = item.planningStatus ? item.planningStatus : "0. Not Started";

  if (dimColor) {
    return tConst.COLOR_DIM;
  } else if (item.Color && item.Color !== "") {
    console.log("Color: " + item.Color, item);
    return item.Color;
  } else if (status === "Resolved" || status === "Closed" || status === "Done") {
    if (planningStatus === tConst.PLANNING_STATUS_NA) {
      return tConst.COLOR_DONE_NA;
    } else {
      return tConst.COLOR_DONE;
    }
  } else if (status === "Removed") {
    if (planningStatus === tConst.PLANNING_STATUS_NA) {
      return tConst.COLOR_DONE_NA;
    } else {
      return tConst.COLOR_REMOVED;
    }
  /* Må avvente hvordan vi introduserer QA i flyten for DevOps 
  } else if (status === "QA" || status === "QA WIP") {
    if (planningStatus === tConst.PLANNING_STATUS_NA) {
      return tConst.COLOR_DONE_NA;
    } else {
      return tConst.COLOR_DONE_QA;
    }
  */
  } else if (planningStatus === "2. FuncSpec Complete" || planningStatus === "3. DevPlan in-progress") {
    return tConst.COLOR_PLANNING;
  } else if (planningStatus === "0. Not Started" || planningStatus === "1. FuncSpec in-progress") {
    return tConst.COLOR_SPECING;
  } else if (planningStatus === "4. Ready-for-coding") {
    return tConst.COLOR_READY4CODING;
  } else if (planningStatus === "9. N/A") {
    return tConst.COLOR_NA;
  } else if (planningStatus === "") {
    return tConst.COLOR_SPECING;
  } else {
    return tConst.COLOR_UNKNOWN;
  }
}
